import { render } from "./VehicleStatusesDisplay.vue?vue&type=template&id=237bfcdc&scoped=true"
import script from "./VehicleStatusesDisplay.vue?vue&type=script&lang=js"
export * from "./VehicleStatusesDisplay.vue?vue&type=script&lang=js"

import "./VehicleStatusesDisplay.vue?vue&type=style&index=0&id=237bfcdc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-237bfcdc"]])

export default __exports__